<script setup lang="ts">
import { PhList, PhX } from '@phosphor-icons/vue'
import { onBeforeUnmount, onMounted, ref } from 'vue'

defineProps<{ webUrl: string; logoUrl: string; encyclopediaEnabled: boolean }>()

const menuOpen = ref(false)
const scrolled = ref(false)

const closeMenu = () => {
  menuOpen.value = false
}

const updateScrolledState = () => {
  scrolled.value = window.scrollY > 8
}

onMounted(() => {
  updateScrolledState()
  window.addEventListener('scroll', updateScrolledState, { passive: true })
})

onBeforeUnmount(() => {
  window.removeEventListener('scroll', updateScrolledState)
})
</script>

<template>
  <header class="site-header" :class="{ 'is-scrolled': scrolled }">
    <div class="container header-inner">
      <a class="brand-link" href="#top" aria-label="麦汁实验室官网首页" @click="closeMenu">
        <img v-if="logoUrl" :src="logoUrl" alt="麦汁实验室" />
        <span v-else class="image-placeholder logo-placeholder">品牌 Logo</span>
      </a>

      <button
        class="menu-toggle"
        type="button"
        :aria-expanded="menuOpen"
        aria-label="切换导航"
        @click="menuOpen = !menuOpen"
      >
        <PhX v-if="menuOpen" :size="24" />
        <PhList v-else :size="24" />
      </button>

      <nav class="main-nav" :class="{ 'is-open': menuOpen }" aria-label="官网导航">
        <a href="#product" @click="closeMenu">产品介绍</a>
        <a href="#subjects" @click="closeMenu">实验内容</a>
        <a v-if="encyclopediaEnabled" href="#encyclopedia" @click="closeMenu">实验百科</a>
        <a href="#download" @click="closeMenu">下载</a>
        <a href="#about" @click="closeMenu">关于我们</a>
        <a class="mobile-login-link" :href="webUrl" @click="closeMenu">注册/登录</a>
      </nav>

      <div class="header-actions">
        <a class="button button-small" :href="webUrl">注册/登录</a>
      </div>
    </div>
  </header>
</template>
